import { Button, Drawer, Theme } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import { T } from 'react-polyglot-hooks';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  drawer: {
    width: 420,
    maxWidth: '100%'
  },
  header: {
    padding: theme.spacing(2, 1),
    display: 'flex',
    justifyContent: 'space-between'
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
}));

const Filter = (props: { className?: string, open: boolean, onClose?: () => void, onFilter?: (values: any) => void, content: any }) => {
  const {open, onClose, onFilter, className, ...rest} = props;
  const classes = useStyles();

  return (
    <Drawer
      anchor="right"
      classes={{paper: classes.drawer}}
      onClose={onClose}
      open={open}
      variant="temporary"
    >
      <div className={classes.header}>
        <Button onClick={onClose} size="small">
          <CloseIcon className={classes.buttonIcon}/>
          <T phrase="Close" />
        </Button>
      </div>
      {props.content}

    </Drawer>
  );
};

export default Filter;
